import { render, staticRenderFns } from "./QuotationPanel.vue?vue&type=template&id=1783f056&scoped=true&"
import script from "./QuotationPanel.vue?vue&type=script&lang=js&"
export * from "./QuotationPanel.vue?vue&type=script&lang=js&"
import style0 from "./QuotationPanel.vue?vue&type=style&index=0&id=1783f056&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1783f056",
  null
  
)

export default component.exports